/* 
 * Ranj Mediator Mapping
 * @author Javier Quevedo-Fernandez
 * Created on 25 September 2013
 */

import SkinKey from "../ui/SkinKey";


export default class MediatorMapping {
    constructor() {
        this._map = new Map();
    }

    /**
     * @param {SkinKey} key - Object with property 'skinClass' which is also used to get the mediator. 
     * @param {Function} mediator - Mediator class 
     */
    map(key, mediator) {
        this._map.set(key, mediator);
    };

    /* Returns the string name of the mediator for a given string name of a skin
     * 
     * @params {SkinKey} key - Object with property 'skinClass' which is used to map the mediator.
     * @return {Function} Mediator class/function 
     */
    mediatorForSkin(key) {
        return this._map.get(key);
    };
}